import React, {Component} from 'react';
import italicsIcon from './italics.png';
import {toolWidth} from "../../twoLinesEditorToolsSpace";
import {EDITOR_TOOL_BTN_COLOR} from "../../../../../constants";

class ItalicsTool extends Component {

    constructor(props) {
        super(props);
        this.state = {
            btnChecked:false
        }
    }
    /**
     * 监听内容变化
     */
    listenContentChange(){
        let italic = this.props.editor.queryCommandState("italic");
        this.setState({btnChecked: italic === 1});
    }

    /**
     * 监听编辑器点击
     */
    listenContentClick(){
        let italic = this.props.editor.queryCommandState("italic");
        this.setState({btnChecked: italic === 1});
    }

    render() {
        let style = {};
        if(this.state.btnChecked){
            style.boxShadow = `-1px -1px ${EDITOR_TOOL_BTN_COLOR.checked}`;
        }else{
            if(style.boxShadow){
                delete style.boxShadow;
            }
        }
        return (
            <span style={{cursor:"pointer"}} onClick={()=>{
                this.props.editor.execCommand( 'italic' );
                this.setState({btnChecked:true});
            }}><img className={"editor-italic-tool-btn"} style={style} width={toolWidth - 2} src={italicsIcon}/>
            <style>{`
                .editor-italic-tool-btn{
                    border: 1px solid #f2f6fc
                }
                .editor-italic-tool-btn:hover{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.hover}
                }
                .editor-italic-tool-btn:active{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.press}
                }
            `}</style>
            </span>
        );
    }
}

export default ItalicsTool;